<template>
  <div
    @mouseenter="isEdit && !is_show_language_popup?(visible = true, tooltip_index = open_tooltip_index+1, increaseOpenTooltipIndex()):(!isEdit?visible = true:'')"
    @mouseleave="isEdit?visibe = true : visible = false"
  >
    <v-tooltip 
      :top="top"
      :right="right"
      :bottom="bottom || (!top && !right && !left)"
      :left="left"
      :value="visible && !hidden"
    >
      <template #activator="{}">
        <slot/>
      </template>
      <div @mouseleave="!is_show_overlay?visible = false:''" class="tooltip-text">
      <TText
        :text="text?text:false"
        :value="value?value:false"
        color="white"
        @showOverlay="is_show_overlay = $event"
        />
      </div>
    </v-tooltip>
  </div>
</template>
<script>
  import {
      mapGetters,
      mapState,
      mapActions,
    } from 'vuex';
  export default {
    props: ['text', 'value', 'hidden'],
    data: () => ({
      visible: false,
      is_show_overlay: false,
      tooltip_index: 0,
    }),
    watch: {
      isEdit() {
        this.visible = false;
      },
      open_tooltip_index() {
        if (this.open_tooltip_index !== this.tooltip_index) {
          this.visible = false;
        }
      }
    },
    computed: {
      ...mapGetters('Language', [
        'isEdit'
      ]),
      ...mapState('View', [
        'open_tooltip_index',
        'is_show_language_popup',
      ]),
      

      top() {
        let a = this.$attrs;
        if (a.top !== undefined) {
          if (a.top || a.top === '') { return true; }
        }
        return false;
      },

      right() {
        let a = this.$attrs;
        if (a.right !== undefined) {
          if (a.right || a.right === '') { return true; }
        }
        return false;
      },

      bottom() {
        let a = this.$attrs;
        if (a.bottom !== undefined) {
          if (a.bottom || a.bottom === '') { return true; }
        }
        return false;
      },

      left() {
        let a = this.$attrs;
        if (a.left !== undefined) {
          if (a.left || a.left === '') { return true; }
        }
        return false;
      },
    },
    methods: {
      ...mapActions('View', [
        'increaseOpenTooltipIndex'
      ]),
    }
  }
</script>
<style scoped>
  .v-tooltip__content {
    pointer-events: auto;
    padding: 0px;
    z-index: 10000 !important;
  }

  .tooltip-text {
    padding: 5px 16px;
  }
</style>
